module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_8.23953abd.png";